<template>
    <header class="header" id="header" v-if="setup != null">
        <div class="container">
            <div class="column-container">
                <div class="col col-left">
                    <div class="upper-element">
                        <div class="lang">
                            <div class="lang--picker">
                                <a href="#" class="lang-link-select">
                                    <svg-icon icon-class="down-arrow" className="icon-down-arrow"/>
                                    <span class="body-lang-ru">Русский</span>
                                    <span class="body-lang-kz">Казахский</span>
                                </a>
                            </div>
                            <div class="select--languages">
                                <ul>
                                    <li class="select-link select-link-ru">
                                        <a href="#" @click.prevent="setLocale('')">Русский</a>
                                    </li>
                                    <li class="select-link select-link-kz">
                                        <a href="#" @click.prevent="setLocale('kz/')">Казахский</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="link-to-present">
                            <a :href="setup.btn_present_group.file" class="btn-present" target="_blank">
                                <svg-icon icon-class="download" className="icon-download"/>
                                <strong>{{setup.btn_present_group.title}}</strong>
                            </a>
                        </div>
                    </div>
                    <div class="down-element">
                        <div class="change-date-time">
                            <ul>
                                <li><a href="#" @click.prevent="changeDayTime('day')">{{setup.btn_change_time.day}}</a></li>
                                <li><a href="#" @click.prevent="changeDayTime('night')">{{setup.btn_change_time.night}}</a></li>
                            </ul>
                        </div>
                        <div class="nav-main navigation-main navigation-main-left">
                            <ul class="list-unstyled nav">
                                <li>    
                                    <a :href="'#section-' + setup.main_page_navigation[0].href" 
                                    v-scroll-to="{
                                        el: '#section-' + setup.main_page_navigation[0].href,
                                        offset: 0
                                    }">
                                        {{setup.main_page_navigation[0].name}}
                                    </a>
                                </li>
                                <li v-for="(nav,index) in setup.main_page_navigation.slice(1, 3)" :key="index">
                                    <a :href="'#section-' + nav.href" 
                                    v-scroll-to="{
                                        el: '#section-' + nav.href,
                                        offset: -74
                                    }">
                                        {{nav.name}}
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col col-center">
                    <div class="main-logo">
                        <a href="#">
                            <img :src="setup.logo" alt="">
                            <img :src="setup.logo_white" class="logo-white" alt="">
                        </a>
                    </div>
                </div>
                <div class="col col-right">
                    <div class="upper-element">
                        <div class="phone-modal-btn">
                            <svg-icon icon-class="phone" className="icon-phone"/>
                            <a href="#" class="btn-phone-modal" @click.prevent="openFormModal">
                                <svg-icon icon-class="phone" className="icon-phone"/>
                                <p>{{setup.header_phone}}</p>
                            </a>
                        </div>
                    </div>
                    <div class="down-element">
                        <div class="nav-main navigation-main navigation-main-right">
                            <ul class="list-unstyled nav">
                                <li v-for="(nav,index) in setup.main_page_navigation.slice(3, setup.main_page_navigation.length)" :key="index">
                                    <a :href="'#section-' + nav.href" 
                                    v-scroll-to="{
                                        el: '#section-' + nav.href,
                                        offset: -74
                                    }">
                                        {{nav.name}}
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="bazis-logo">
                        <a :href="setup.logo_bazis.link" target="_blank">
                            <img :src="setup.logo_bazis.img" alt="">
                            <img :src="setup.logo_bazis_white" class="logo-white" alt="">
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
    export default {
        name: 'AppHeader',
        components: {
        },
        data () {
            return {
            }
        },
        methods: {
            setLocale(lang) {
                localStorage.setItem('language', lang);
                document.location.reload(true);
            },
            changeDayTime(time) {
                localStorage.setItem('dayTime', time);
                document.querySelector('body').dataset.themeTime = localStorage.getItem('dayTime');
            },
            changeLang () {
                var dataLang = window.body.data('language'),
                    btnKz = $('.body-lang-kz'),
                    btnRu = $('.body-lang-ru'),
                    selectRu = $('.select-link-ru'),
                    selectKz = $('.select-link-kz'),
                    link = $('.lang-link-select'),
                    switchContainer = $('.select--languages');
                if (dataLang == '') {
                    btnRu.addClass('active');
                    selectRu.addClass('active');
                } else {
                    btnKz.addClass('active');
                    selectKz.addClass('active');
                }
                link.on('click', function(e){
                    e.preventDefault();
                    e.stopPropagation();
                    $(this).stop(true).toggleClass('open');
                    $(this).closest('.lang').find('.select--languages').stop(true).toggleClass('open');
                });
                $(document).on('click', function closeMenu (e){
                    if(link.has(e.target).length === 0){
                        switchContainer.removeClass('open');
                        link.removeClass('open');
                    } else {
                        $(document).one('click', closeMenu);
                    }
                });
            },
            openFormModal() {
                this.$store.commit('Open_Form_Modal', true);
            }
        },
        computed: {
            setup() {
                return this.$store.state.pageSetup
            }
        },
        created () {
        },
        mounted () {
            this.$store.watch(
                (state) => state.pageSetup,
                (newValue) => {
                    if (newValue.main_page_navigation.length >= 5) {
                        this.changeLang();
                    }
                }
            )
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/header/header.scss';
    @import '@/styles/components/nav-main/nav-main.scss';
</style>